/**
 * Dashboard Offene Rechnungen deep-links use /invoice?approvalStage=…&approvalRole|approvalContactId|approvalEmail.
 * Impower does not forward those params; inject them onto invoice list collection GETs (fetch + XHR).
 * Sibling list patches already use XHR for the same collection path (incl. trailing `/`).
 */
;(function luxInvoiceListApprovalStageFetchPatch() {
  const APPROVAL_KEYS = [
    'approvalStage',
    'approvalRole',
    'approvalContactId',
    'approvalEmail',
  ]
  const INVOICES_COLLECTION_SUFFIX = '/pmp-accounting/api/v1/invoices'

  function pageApprovalParams() {
    try {
      const sp = new URL(window.location.href).searchParams
      const out = {}
      for (const key of APPROVAL_KEYS) {
        const value = sp.get(key)
        if (value) out[key] = value
      }
      if (
        !out.approvalStage &&
        !out.approvalRole &&
        !out.approvalContactId &&
        !out.approvalEmail
      ) {
        return null
      }
      return out
    } catch (_e) {
      return null
    }
  }

  function isInvoiceListCollectionGet(urlStr, method) {
    const m = String(method || 'GET').toUpperCase()
    if (m !== 'GET' && m !== '') return false
    if (!urlStr) return false
    try {
      const path = new URL(urlStr, window.location.origin).pathname || ''
      const pos = path.indexOf(INVOICES_COLLECTION_SUFFIX)
      if (pos === -1) return false
      const tail = path.slice(pos + INVOICES_COLLECTION_SUFFIX.length)
      // Collection is "" or "/" — anything else is a detail/sub-resource.
      return tail === '' || tail === '/'
    } catch (_e) {
      return false
    }
  }

  function applyApprovalParamsToUrl(urlStr, method) {
    const params = pageApprovalParams()
    if (!params || !isInvoiceListCollectionGet(urlStr, method)) return null

    let u
    try {
      u = new URL(urlStr, window.location.origin)
    } catch (_e) {
      return null
    }

    let changed = false
    for (const key of APPROVAL_KEYS) {
      const value = params[key]
      if (!value || u.searchParams.get(key) === value) continue
      u.searchParams.set(key, value)
      changed = true
    }
    if (!changed) return null

    const pathAndQuery = u.pathname + u.search + u.hash
    if (/^https?:\/\//i.test(urlStr)) return u.toString()
    return pathAndQuery
  }

  function patchFetchInput(input, init) {
    const method =
      (init && init.method) ||
      (typeof Request !== 'undefined' && input instanceof Request
        ? input.method
        : 'GET') ||
      'GET'
    if (typeof input === 'string') {
      return applyApprovalParamsToUrl(input, method)
    }
    if (typeof Request !== 'undefined' && input instanceof Request) {
      const patched = applyApprovalParamsToUrl(input.url, method)
      return patched ? new Request(patched, input) : null
    }
    const urlStr = (input && input.url) || ''
    return urlStr ? applyApprovalParamsToUrl(urlStr, method) : null
  }

  const innerFetch = window.fetch
  window.fetch = function luxInvoiceApprovalStageFetch(input, init, ...rest) {
    const patched = patchFetchInput(input, init)
    if (patched != null) {
      return innerFetch.call(this, patched, init, ...rest)
    }
    return innerFetch.call(this, input, init, ...rest)
  }

  const xhrOpen = XMLHttpRequest.prototype.open
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    let nextUrl = url
    if (typeof url === 'string') {
      const patched = applyApprovalParamsToUrl(url, method)
      if (patched) nextUrl = patched
    }
    return xhrOpen.call(this, method, nextUrl, ...rest)
  }
})()
